<template>
    <div>
        <a-modal
        class="modalStyle"
        :dialog-style="{ top: '20px' }"
        :width="595"
        :visible="previewModalVisible"
        :footer="null"
        @cancel="handlePreviewModalCancel"
        >
        <div class="container">
            <div class="d-flex justify-content-between">
                <div class="logoContainer">
                    <div class="image"></div>
                </div>
                <div class="invoice-text">Waybill</div>
            </div>
            <div class="d-flex justify-content-between">
                <div class="cowtribe-container">
                    <br>
                    <h3 >{{ data.sourceLocationName }} </h3>
                    <!-- <p>Accra, Ghana</p>
                    <p>{{ data.cowtribeDate ? data.cowtribeDate : 'N/A'}}</p> -->
                </div>
                <div class="retailer-details">
                    <!-- <p>Billed to,</p> -->
                    <p>{{ data.destinationLocationName }}</p>
                    <!-- <div>
                        {{ data.retailerAddress ? data.retailerAddress : 'N/A'}}
                    </div> -->
                </div>
                <!-- <div class="phoneNumber">
                    {{ data.phoneNumber ? data.phoneNumber : 'N/A'}}
                </div> -->
                <div class="divider">
                    <a-divider></a-divider>
                </div>
                <div>
                    <div class="d-flex justify-content-between">
                      <div class="invoice-header-1">Waybill number</div>
                      <div class="invoice-header-2">Requested By</div>
                      <div class="invoice-header-3">Expected At</div>
                    </div>
                    <div class="d-flex justify-content-between">
                      <div class="invoice-value-1">{{ data.requestId ? `#${data.requestId}` : 'N/A'}}</div>
                      <div class="invoice-value-2">{{ data.requestedBy ? data.requestedBy : 'N/A'}}</div>
                      <div class="invoice-value-3">{{ data.expectedAt ? data.expectedAt : 'N/A'}}</div>
                    </div>
                </div>
                 <div class="divider-2">
                    <a-divider></a-divider>
                </div>
                <div class="tableContainer tableFixHead">
                     <table class="table table-striped table-hover table-bordered fixed_header">
                    
                        <thead>
                            <tr>
                            <th scope="col">Product Name</th>
                            <th scope="col">Quantity</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="product in data.fulfillmentLines" :key="product.productId">
                                <td>{{ product.productBrandName }}</td>
                                <td>{{ product.quantity }}</td>
                            </tr> 
                        </tbody>
                    </table>
                </div>
                <div class="total d-flex justify-content-between">
                    <p>Total Products(s)</p>
                    <p>{{ displayTotalQuantity }} </p>
                </div>

                <div class="divider-3">
                    <a-divider></a-divider>
                </div>

                <div class="d-flex justify-content-between">
                    <div class="address-value-1">www.zhulia.me</div>
                    <div class="address-value-2">sales@zhulia.me</div>
                    <div class="address-value-3">+233559691061</div>
                </div>
            </div>

        </div>
        
        </a-modal>
    </div>
</template>

<script>
    export default {
        name:'PreviewWaybill',
        data(){
            return{
                previewModalVisible: false,
                data: {
                    destinationLocationName: '',
                    expectedAt:'',
                    requestId: '',
                    requestedBy: '',
                    total:'',
                    sourceLocationName: '',
                    fulfillmentLines: [],
                }
            }
        },
        computed: {
            displayTotalQuantity(){
                // console.log("in tableData |", this.tableData)
                const itemQuantity = this.data.fulfillmentLines.map(item => {
                    if(item.quantity){
                        return parseInt(item.quantity) 
                    }else{
                        return 0
                    }
                })
                // console.log("in each itemAmount |", itemQuantity)
                const totalQuantity = itemQuantity.reduce((acc, item) => acc + item, 0);
                // console.log("in computed totalAmt |", totalQuantity)
                return parseInt(totalQuantity)
            },
        },
        methods:{
            handlePreviewModalCancel(){
                this.previewModalVisible = false
            },
            showPreviewData(previewData){
                this.data = previewData
                this.previewModalVisible = true
            },
        }
    }
</script>

<style scoped>
.modalStyle >>> .ant-modal-header {
    border-bottom: none;
}

.modalStyle >>> .ant-modal-footer {
    border-top: none;
}
.modalStyle{
    display: flex;
    justify-content: center;
}
.container{
    height: 842px;
    background: #FFFFFF;
}

.logoContainer{
    position: absolute;
    width: 212px;
    height: 64px;
    left: 31px;
    top: 25px;
    color: #FFFFFF;
    background: #266423;
}
.image{
    position: absolute;
    width: 156px;
    height: 39px;
    left: 56px;
    top: 12px;
    background: url('../../../assets/img/invoice-log.png');
}
.invoice-text{
    position: absolute;
    width: 136px;
    height: 44px;
    left: 429px;
    top: 30px;
    font-weight: 600;
    font-size: 36px;
    line-height: 44px;
    text-align: right;
    letter-spacing: 0.05em;
    color: #6F6F84;
}

.cowtribe-container h3 {
    position: absolute;
    width: 354px;
    height: 35px;
    left: 30px;
    top: 105px;
    font-weight: 500;
    font-size: 24px;
    line-height: 29px;
    color: #000000;
}

.cowtribe-container p:first-of-type{
    position: absolute;
    width: 242px;
    height: 17px;
    left: 30px;
    top: 143px;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}

.cowtribe-container p:last-of-type{
    position: absolute;
    width: 242px;
    height: 17px;
    left: 30px;
    top: 187px;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #222234;
}

.retailer-details p:first-of-type{
    position: absolute;
    width: 100%;
    height: 16px;
    left: -20px;
    top: 105px;
    font-size: 14px;
    text-align: right;
    color: #6F6F84;
}

.retailer-details p:nth-child(2){
    width: 100%;
    margin-left: 232px;
    margin-top: 89px;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    text-align: right;
    color: #222234;
}

.phoneNumber{
    width: 100%;
    margin-left: 145px;
    margin-top: 150px;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    text-align: right;
    color: #222234;
}


.retailer-details div{
    position: absolute;
    width: 126px;
    height: 60px;
    left: 439px;
    top: 133px;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 25px;
    text-align: right;
    color: #222234;
}
.divider{
    position: absolute;
    width: 535px;
    height: 0px;
    left: 30px;
    top: 156px;
}
.divider-2{
    position: absolute;
    width: 535px;
    height: 0px;
    left: 30px;
    top: 251px;
}

.divider-3{
    position: absolute;
    width: 535px;
    height: 0px;
    left: 30px;
    top: 815px;
}

.invoice-header-1{
    position: absolute;
    width: 102px;
    height: 17px;
    left: 30px;
    top: 199px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}

.invoice-header-2{
    position: absolute;
    width: 110px;
    height: 17px;
    left: 243px;
    top: 199px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}

.invoice-header-3{
   position: absolute;
    width: 110px;
    height: 17px;
    left: 467px;
    top: 199px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}

.invoice-value-1{
    position: absolute;
    width: 100px;
    height: 17px;
    left: 30px;
    top: 233px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #222234;
}

.invoice-value-2{
    position: absolute;
    width: 200px;
    height: 17px;
    left: 244px;
    top: 233px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #222234;
}

.invoice-value-3{
    position: absolute;
    width: 105px;
    height: 17px;
    left: 467px;
    top: 233px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #222234;
}
.tableContainer{
    position: absolute;
    width: 524px;
    height: 195px;
    left: 31px;
    top: 317px;
    background: #FAFAFC;
    border: 1px solid #BCB0C4;
    box-sizing: border-box;
    border-radius: 8px;
}

.tableFixHead {
        overflow-y: auto;
        height: 280px;
      }
.tableFixHead thead th {
position: sticky;
top: 0;
}
.tableFixHead table {
border-collapse: collapse;
width: 100%;
}
.tableFixHead th,
.tableFixHead td {
padding: 8px 16px;
border: 1px solid #ccc;
}
.tableFixHead th {
background: #eee;
}
.subTotal{
    position: absolute;
    width: 88%;
    height: 15px;
    left: 31px;
    top: 599px;
}

.total{
    position: absolute;
    width: 88%;
    height: 15px;
    left: 31px;
    top: 620px;
}

.total p:first-of-type{
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 15px;
    letter-spacing: 0.05em;
    color: #6F6F84;
}

.subTotal p:first-of-type{
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 15px;
    letter-spacing: 0.05em;
    color: #6F6F84;
}

.subTotal p:last-of-type{
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 15px;
    color: #222234;
}

.total p:last-of-type{
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 15px;
    color: #222234;
}
.termContainer {
    position: absolute;
    height: 12px;
    left: 31px;
    top: 670px;
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    font-size: 13px;
    letter-spacing: 0.05em;
    color: #6F6F84;
}

.termContainer p:first-of-type{
    font-size: 13px;
}

.ant-divider-horizontal {
    border: 1px solid #C7C7C7;
}

.paymentDetails{
    position: absolute;
    height: 15px;
    left: 30px;
    top: 746px;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.05em;
    color: #6F6F84;
}

.bog{
    position: absolute;
    height: 17px;
    left: 30px;
    top: 768px;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}
.acount{
    position: absolute;
    height: 17px;
    left: 30px;
    top: 791px;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}


.adresss{
    position: absolute;
    height: 17px;
    left: 30px;
    top: 812px;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}

.address-value-1{
    position: absolute;
    width: 100px;
    height: 17px;
    left: 30px;
    top: 846px;
    font-size: 14px;
    line-height: 17px;
    color: #418A49;
}
.address-value-2{
    position: absolute;
    width: 110px;
    height: 17px;
    left: 252px;
    top: 846px;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}
.address-value-3{
    position: absolute;
    /* width: 112px; */
    height: 17px;
    left: 466px;
    top: 846px;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}
</style>